import React from "react"
import SimpleReactLightbox, { SRLWrapper, useLightbox } from "simple-react-lightbox"
import LightboxBtn from "./Lightbox-btn"

export default function Lightbox({images, globalt, classes})
{       
    const c = classes !== undefined ? ' '+classes : ''
    
    const options = 
    {
        settings: 
        {
            //overlayColor: "rgb(25, 136, 124)",
        },
        buttons: 
        {
            showDownloadButton: false,
        }
    }
    
    return (
        <div className={"lightbox"+c}>
            <SimpleReactLightbox>
                <SRLWrapper options={options}>
                {
                    images.map((image, index) => 
                    {                          
                        if(image.localFile === null) return <></>
                              
                        let last = ''
                        let alt = image.alt || (globalt || '')
                        const classes = index > 7 ? 'img hidden' : 'img photo'                        
                        const total = images.length
                        const img = image.localFile.publicURL !== null ? image.localFile.publicURL : ''
                        let thumb = img

                        if(image.localFile.childImageSharp !== null)
                            if(image.localFile.childImageSharp !== undefined)
                                thumb = image.localFile.childImageSharp.gatsbyImageData.images.fallback.src               
                       
                        if(total < 8 && index >= total-1) last = ' last'
                        if(last === '' && index === 7) last = ' last'

                        const ifLast = () =>
                        {
                            if(last === '') return

                            return(
                                <LightboxBtn start={index+1} total={total}/>
                            )
                        }

                        const thumbStyle =
                        {
                            backgroundImage: "url(" + thumb + ")"
                        }

                        return(
                            <div className="thumb">
                                <a className={classes+last} href={img} style={ thumbStyle } >
                                    <img src={thumb} alt={alt} loading="lazy" />                                  
                                </a>   
                                {ifLast()}
                            </div>
                        )                    
                    })
                }
                </SRLWrapper>
            </SimpleReactLightbox>
        </div>       
    ) 
}